import { useEffect, ReactNode } from "react";
import { AceConnectionStatus, ArchaxLogo, useAce } from "@archax/web-lib";
import "./reconnection-overlay.css";

const ReconnectionOverlay = ({ children }: { children: ReactNode }) => {
  const { connectionStatus } = useAce();

  useEffect(() => {
    if (connectionStatus === AceConnectionStatus.RECONNECTING) {
      // Only set if not already set to hidden and pointerEvents none (this is cause MUI tooltips/popovers also lock scroll)
      const alreadyHidden = document.body.style.overflow === "hidden";
      if (alreadyHidden) return;
      const originalOverflow = document.body.style.overflow;
      const originalPointerEvents = document.body.style.pointerEvents;
      document.body.style.overflow = "hidden";
      document.body.style.pointerEvents = "none";
      return () => {
        document.body.style.overflow = originalOverflow;
        document.body.style.pointerEvents = originalPointerEvents;
      };
    }
  }, [connectionStatus]);

  return (
    <>
      {connectionStatus === AceConnectionStatus.RECONNECTING && (
        <div className="reconnection-overlay">
          <div
            style={{
              position: "fixed",
              zIndex: 1401,
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgb(10, 8, 31)",
              opacity: 0.8,
            }}
          />
          <div
            className="loader"
            style={{
              zIndex: 1401,
              borderRadius: 24,
              width: 106,
              height: 106,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "fixed",
              padding: 20,
              background:
                "linear-gradient(132deg, rgba(255, 255, 255, 0.40) -8.67%, rgba(255, 255, 255, 0.10) 53.98%)",
              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
            }}
          >
            <span />
            <span />
            <ArchaxLogo
              aria-label="Reconnecting"
              width={"72px"}
              height={"57px"}
            />
          </div>
        </div>
      )}
      {children}
    </>
  );
};

export { ReconnectionOverlay };
